module.exports = __webpack_public_path__ + "static/apps-672a768369fd7a9bf301940de6419909.png";